import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import { API_KEY } from '../utils/constants';
import { getWithdrawHistoryAPI } from '../api/api';
import Loader from '../components/loader';

function WithdrawHistory() {
  const [history, setHistory] = useState([]);
  const [totalWithdraw, setTotalWithdraw] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const getFundData = async () => {
    const userData = await localStorage.getItem('user');
    const user_uid = JSON.parse(userData).uid;

    const formData = new FormData();
    formData.append('__api_key__', API_KEY);
    formData.append('user_uid', user_uid);

    await getWithdrawHistoryAPI(formData)
      .then((res) => {
        if (res.data.state === 'OK') {
          const sortedData = res.data.data.meta.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setHistory(sortedData);
          
          
          // Calculate Total Withdrawn Amount
          const total = sortedData
          .filter(item => item.state === 'Success')  // Filter only successful transactions
          .reduce((sum, item) => sum + Number(item.amount), 0);
          
          setTotalWithdraw(total);

          setIsLoading(false);
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getFundData();
  }, []);

  return (
    <div className='main-2'>
      <Header title='Withdraw History' isBack />
      <div className='container mt-5'>

        {/* Total Withdraw Amount */}
        <div className=' p-3 mb-3 rounded-4 bg-white text-center'>
          <h5 className='fw-bold' style={{ color: '#6c62ff' }}>Total Withdrawn</h5>
          <h2 className='fw-bold' style={{ color: '#333' }}>₹ {totalWithdraw}</h2>
        </div>

        {/* Withdraw History Table */}
        <div className='table-responsive'>
          <table className='table table-bordered shadow-sm bg-white text-center'>
            <thead className='bg-primary text-white'>
              <tr>
                <th>Sr No</th>
                <th>Withdraw Amount</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {history.length > 0 ? (
                history.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>₹ {item.amount}</td>
                    <td>{new Date(item.created_at).toLocaleString()}</td>
                    <td 
                      className={item.state === 'Success' ? 'text-success' : 'text-danger'}>
                      {item.state}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted">No Withdraw History Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Loader isLoading={isLoading} />
    </div>
  );
}

export default WithdrawHistory;


/*
import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import { API_KEY } from '../utils/constants';
import { getWithdrawHistoryAPI } from '../api/api';
import Loader from '../components/loader';

function WithdrawHistory() {
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getFundData = async () => {
    const userData = await localStorage.getItem('user');
    const user_uid = JSON.parse(userData).uid;

    const formData = new FormData();
    formData.append('__api_key__', API_KEY);
    formData.append('user_uid', user_uid);

    await getWithdrawHistoryAPI(formData)
      .then((res) => {
        if (res.data.state === 'OK') {
          setHistory(res.data.data.meta);
          setIsLoading(false)
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getFundData();
  }, []);

  return (
    <div className='main-2 bg-4'>
      <Header title='Withdraw History' isBack />
      <div className='container mt-5'>
        {history.map((item, index) => (
          <div className='shadow-sm p-2 rounded-2 my-2'>
            <div className='d-flex justify-content-around'>
              <h5 style={{color: '#6c62ff'}}>{item.amount}</h5>
              <h6>{item.state}</h6>
            </div>
            <p className='m-0 text-center'>{item.created_at}</p>
          </div>
        ))}
      </div>
      <Loader isLoading={isLoading} />
    </div>
  );
}

export default WithdrawHistory;
*/